import Popup from '../../User/popup';
import { Price } from '../__simple/_price';

export default function FinancingDetailsPopup({ show, setShow, financeSettings, finance, lang, trans }) {
    return (
        <Popup show={show}>
            <div className="offer-popup nice-flex nice-flex-center">
                <div className="offer-popup-container p-4">
                    <div className="offer-popup-container-header">
                        <h1 className="text-balck text-bold text-24 text-center">{trans('finance:finance')}</h1>
                        <span
                            className="offer-popup-container-header-close text-block text-gray"
                            onClick={() => setShow(false)}
                        ></span>
                    </div>
                    <div className="ruler-2 mb-3"></div>
                    <div className="popup-content">
                        <div className="mx-10 my-10">
                            {financeSettings && (
                                <div className="nice-flex nice-flex-column nice-gap-0rem px-10">
                                    <div className="nice-flex nice-flex-row nice-flex-space-between my-4">
                                        <h3 className="text-gray-dark text-20">{trans('finance:finance')}</h3>
                                        <p className="text-primary-dark text-20">
                                            {lang == 'ar' ? financeSettings.DescriptionAr : financeSettings.DescriptionEn}
                                        </p>
                                    </div>
                                    <div className="nice-flex nice-flex-row nice-flex-space-between my-4">
                                        <h3 className="text-gray-dark text-20">{trans('finance:period')}</h3>
                                        <p className="text-primary-dark text-20">{finance?.period}</p>
                                    </div>
                                    <div className="nice-flex nice-flex-row nice-flex-space-between my-4">
                                        <h3 className="text-gray-dark text-20">{trans('finance:management_fees')}</h3>
                                        <p className="text-primary-dark text-20"><Price price={finance?.mangFees} showZero={true} /></p>
                                    </div>
                                    <div className="nice-flex nice-flex-row nice-flex-space-between my-4">
                                        <h3 className="text-gray-dark text-20">{trans('finance:monthPayment')}</h3>
                                        <p className="text-primary-dark text-20"><Price price={finance?.price} showZero={true} /></p>
                                    </div>
                                    <div className="nice-flex nice-flex-row nice-flex-space-between my-4">
                                        <h3 className="text-gray-dark text-20">{trans('finance:advance_payment')}</h3>
                                        <p className="text-primary-dark text-20"><Price price={finance?.first} showZero={true} /></p>
                                    </div>
                                    <div className="nice-flex nice-flex-row nice-flex-space-between my-4">
                                        <h3 className="text-gray-dark text-20">{trans('finance:lastPayment')}</h3>
                                        <p className="text-primary-dark text-20"><Price price={finance?.last} showZero={true} /></p>
                                    </div>
                                    <div className="ruler-2 mb-3"></div>
                                    <div className="mx-2 my-10 nice-flex nice-flex-row">
                                        <img src="/assets/icons/info.svg" className="mx-3 text-inline-block nice-max-icon" alt="" />
                                        <p className="text-12 text-bold text-gray text-inline-block">{trans('finance:finance_note')}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    );
}